/**
 * Type filters for the notification popper.
 *
 * Resolved is deliberately not one of these: it is a state, not a type, and it is controlled by its
 * own toggle so it can be hidden from every filter at once.
 */
export enum NotificationTypeFilter {
  ALL = 0,
  CONFIRMED = 1,
  RESCHEDULE = 2,
  CALLBACK = 3,
  ACTION_TAG = 4
}

export const NOTIFICATION_FILTER_LABELS: { filter: NotificationTypeFilter; label: string }[] = [
  { filter: NotificationTypeFilter.ALL, label: 'All' },
  { filter: NotificationTypeFilter.CONFIRMED, label: 'Confirmed' },
  { filter: NotificationTypeFilter.RESCHEDULE, label: 'Reschedule' },
  { filter: NotificationTypeFilter.CALLBACK, label: 'Callback' },
  { filter: NotificationTypeFilter.ACTION_TAG, label: 'Action tag' }
];

/**
 * Whether a notification belongs under a given type filter. Resolved state is handled separately,
 * so this only ever looks at the type.
 */
export const matchesTypeFilter = (notification: NotificationModel, filter: NotificationTypeFilter): boolean => {
  if (filter === NotificationTypeFilter.ALL) return true;
  if (filter === NotificationTypeFilter.CONFIRMED) return notification.type === 'CONFIRMED' || notification.type === 'PENDING CONFIRMED';
  if (filter === NotificationTypeFilter.RESCHEDULE) return notification.type === 'RESCHEDULE';
  if (filter === NotificationTypeFilter.CALLBACK) return notification.type === 'CALLBACK';
  if (filter === NotificationTypeFilter.ACTION_TAG) return notification.type === 'ACTIONTAG';
  return true;
};

/**
 * Shown when a filter turns up nothing. An empty feed and an empty filter are different situations,
 * and "No notifications" in answer to picking Callback reads as a bug rather than an answer.
 */
export const emptyFilterMessage = (filter: NotificationTypeFilter): string => {
  if (filter === NotificationTypeFilter.CONFIRMED) return 'No confirmed jobs waiting';
  if (filter === NotificationTypeFilter.RESCHEDULE) return 'No reschedules waiting';
  if (filter === NotificationTypeFilter.CALLBACK) return 'No callbacks waiting';
  if (filter === NotificationTypeFilter.ACTION_TAG) return 'No action tags waiting';
  return "You're all caught up";
};
